
const ErrorPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen ">
      {/* Error Image */}
      <img
        src="https://thumbs.dreamstime.com/b/d-person-using-magnifying-glass-searching-inspecting-concept-exploration-figure-holding-representing-act-321657133.jpg"
        alt="Error 404"
        className="w-64 h-64 mb-8 object-cover border-none"
      />

      {/* Error Message */}
      <h1 className="text-6xl font-bold text-green-800 mb-4">404</h1>

      {/* Error Description */}
      <p className="text-4xl text-green-600 mb-4">Oops!!!</p>
      <p className="text-2xl text-green-600">Page not found</p>
    </div>
  );
};

export default ErrorPage;
